export enum FontWeight {
  light = 200,
  regular = 400,
  bold = 700,
}
